import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { GET_DRIVER_TITLE } from 'Store/AssetManagement/DriverTitle/DriverTitleType';
import { setDriverDetail } from 'Store/AssetManagement/DriverTitle/DriverTitleAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getDriverTitles(request: any): any {
    let payloadData : IPayload = {
        apiType : apiType.AssetManagement,
        endpoint : `assets/dropdown/vehicle/drivertitle?isJobTitleFilter=${request?.isJobTitle}`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    
    try {
        yield put(globalLoaderText("Fetching Driver titles...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp,payloadData
        );

        yield put(setDriverDetail(response));
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setDriverDetail([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetDriverTitles() {
    yield takeEvery(GET_DRIVER_TITLE, getDriverTitles)
}

export default function* combinedSaga() {
    yield all([
        watchGetDriverTitles()
    ])
}
